import ConsentModel from './consent';
import { getConsentData } from '../util/consent-string';
export default class DissentedStubModel extends ConsentModel {
    load() {
        this.consentData = getConsentData(this.vendorList);
        this.metadata = this.consentData.getConsentString();
        this.consented = false;
    }
}
